import { IKnmDocumentType } from 'APIPackage/CatalogsModule/interfaces/IKnmDocumentType';

import { IKnmDocumentTypeSelectOption } from '../interfaces/IKnmDocumentTypeSelectOption';

export const createKnmDocumentTypeSelectOption = (knmDocumentType: IKnmDocumentType): IKnmDocumentTypeSelectOption => ({
  ...knmDocumentType,
  label: knmDocumentType.name,
  value: knmDocumentType.code,
});
